import type { FetchConfig } from '../helper-types';
import type { components, paths } from './portal-api-definition';

export function createNloCommunicationPreferencesApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		get: (location: components['schemas']['PreferenceLocation'], vertical: components['schemas']['ComPrefsVertical']) =>
			client.GET(`/api/my/common/communication-preferences/v2/{vertical}`, {
				params: { path: { vertical }, query: { location: location } },
			}),
		post: (args: components['schemas']['CommonCommunicationPreferenceEditRequest']) =>
			client.POST('/api/my/common/communication-preferences/v2', { body: args }),
	};
}
